import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import BotCard from "../components/BotCard";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRobot} from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';

function Bots() {
  const { user } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [bots, setBots] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchBots: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setBots(data.bots);
      }
    })
    .catch(err => {
    })
  }, [user]);


  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Buy Bot" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Buy Bot" icon={<FontAwesomeIcon icon={faRobot} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <h5 className="fw-bold text-white mt-4 mb-0">Trading Bots</h5>
            <p className="mb-3" style={{fontSize:'14px'}}>This trading bot is built to automate fast crypto day-trading sessions by executing trades quickly and efficiently without emotional interference. Its purpose is to take advantage of short-term market movements by opening and closing positions within a short time frame, which helps ensure trades are completed on time and funds are readily available for withdrawal. By operating 24/7, monitoring multiple markets, and applying pre-set strategies with proper risk management, the bot increases consistency and trading accuracy, giving traders a strong advantage in fast-moving markets and the potential to achieve higher overall profits compared to manual trading.</p>
            <div className="row">
              {bots.map((bot) => (
                <div className="col-xxl-3 col-lg-4 col-6 col-12">
                    <BotCard key={bot.id} bot_id={bot.bot_id} bot_photo={<img src={`/uploads/${bot.bot_photo}`} alt={bot.bot_name} width="100%" height="100%" style={{objectFit:"cover"}} />} bot_name={bot.bot_name} duration={bot.duration} bot_amount={bot.bot_amount} bot_level={bot.bot_level}/>
                </div>
              ))}
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Bots